module.exports = __webpack_public_path__ + "static/media/facebook.e62b1226.svg";